import { render, staticRenderFns } from "./owner-payments.vue?vue&type=template&id=1fb8813f&scoped=true"
import script from "./owner-payments.vue?vue&type=script&lang=js"
export * from "./owner-payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb8813f",
  null
  
)

export default component.exports